import { Quote } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal, Eyebrow } from "@/components/Reveal";

const IMG = "https://images.unsplash.com/photo-1477332552946-cfb384aeaf1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwbGlmZXN0eWxlJTIwd2VsbG5lc3MlMjBleGVyY2lzZSUyMG1pbmQlMjBiYWxhbmNlfGVufDB8fHx8MTc4OTcyMzI1N3ww&ixlib=rb-4.1.0&q=85";

export default function CompanySection() {
  const { t } = useLanguage();

  return (
    <section id="company" data-testid="company-section" className="relative pt-32 sm:pt-40 pb-20 sm:pb-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <Eyebrow>{t.company.eyebrow}</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-4 font-display font-bold tracking-tight leading-snug text-2xl sm:text-3xl lg:text-4xl text-slate-900" data-testid="company-name">
                {t.company.name}
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <h3 className="mt-6 font-display font-semibold text-lg sm:text-xl text-teal-700">{t.company.storyTitle}</h3>
            </Reveal>
            <Reveal delay={0.3}>
              <p className="mt-4 text-base sm:text-lg leading-relaxed text-slate-600">{t.company.storyText}</p>
            </Reveal>
            <Reveal delay={0.4}>
              <blockquote className="mt-8 flex items-start gap-4 border-s-4 border-lime-500 ps-5 py-1">
                <Quote size={20} className="text-lime-500 shrink-0 mt-1" />
                <span className="font-display font-bold text-lg sm:text-xl text-slate-800">{t.company.quote}</span>
              </blockquote>
            </Reveal>
          </div>

          <div className="lg:col-span-6">
            <Reveal delay={0.2}>
              <div className="relative">
                <div className="rounded-[2.5rem] overflow-hidden shadow-2xl border-[6px] border-white">
                  <img src={IMG} alt="Personal transformation journey" className="w-full h-[340px] sm:h-[420px] object-cover" data-testid="company-image" />
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
